import { useState } from "react";
import CommonModal from "./Modal/CommonModal";
import CommonModalTitle from "./Modal/CommonModalTitle";
import PackagingEnquiryForm from "./ServicesFrom/PackagingEnquiryForm";

export default function PackagingServices() {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <section className="pb-5 pt-0" style={{ backgroundColor: "#fff" }}>
        <div className="services-pages-banner">
          <div>
            <img
              src="/assets/images/packaging-services-banner.png"
              alt="Not found"
              className="w-100"
            />
            <img
              src="/assets/images/packaging-services-banner-mobile.webp"
              alt="Not found"
              className="w-100 service-mobile-view-banner"
            />
          </div>
          <div>
            <button
              className="btn getquoteBtn mt-5 mb-3 mx-2 text-center d-block banner-button"
              onClick={handleOpen}
            >
              <img
                src="/assets/images/arrow_right.svg"
                alt="Not found"
                height={12}
              />
              <span
                className="px-2 d-inline-block fw-bold p-0"
                onClick={handleOpen}
              >
                Request A Quote
              </span>
            </button>
          </div>
        </div>
        <div className="container">
          <section className="courier-mode">
            <div className="row mb-5">
              <div className="col-md-6">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/wooden-box-packing.png"
                    alt="Not found"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>1. Wooden Box Packing</h3>
                  <h6 className="mb-3">
                    For: Highly fragile or valuable items needing full
                    protection
                  </h6>
                  <p>
                    Our wooden box packing ensures that your items are
                    completely enclosed, preventing any external impact from
                    damaging the contents. Ideal for electronics, glassware, or
                    delicate goods that need 360° protection.
                  </p>

                  <ul>
                    <li>
                      <p>Completely enclosed</p>
                    </li>
                    <li>
                      <p>Suitable for high-value and breakable goods</p>
                    </li>
                    <li>
                      <p>Recommended for long-haul freight</p>
                    </li>
                  </ul>

                  <p>
                    Perfect for shoppers buying from multiple retailers or bulk
                    buyers sourcing across categories.
                  </p>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>2. Wooden Crate Packing</h3>
                  <h6 className="mb-3">
                    For: Fragile goods that require protection and easy customs
                    inspection
                  </h6>
                  <p>
                    Wooden crate packing leaves small gaps between slats—perfect
                    for customs visibility without unpacking. A great option
                    when you need a balance between durability, safety, and
                    clearance convenience.
                  </p>

                  <ul>
                    <li>
                      <p>Customs-friendly design</p>
                    </li>
                    <li>
                      <p>Partial coverage with structural strength</p>
                    </li>
                    <li>
                      <p>No need to unseal during inspection</p>
                    </li>
                  </ul>

                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/wooden-crate-packing.png"
                    alt="Not found"
                  />
                </div>
              </div>
            </div>

            <div className="row mb-5">
              <div className="col-md-6 ">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/carton-packing.png"
                    alt="Not found"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>3. Carton Packing</h3>
                  <p>For: Regular household items or soft goods</p>

                  <ul>
                    <li>
                      <p>
                        Used for clothes, light furnishings, and general
                        domestic goods. Carton boxes are cost-effective and
                        sturdy enough for local and short-distance deliveries.
                      </p>
                    </li>
                    <li>
                      <p>
                        Ideal for packing clothes and regular household or
                        retail goods
                      </p>
                    </li>
                    <li>
                      <p>Multiple sizes available</p>
                    </li>
                    <li>
                      <p>Budget-friendly option</p>
                    </li>
                  </ul>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
            </div>

            <div className="row mb-5">
              <div className="col-md-6">
                <div className="transit-insurance-service">
                  <h3>4. Customized Packing for Fragile Items</h3>
                  <h6 className="mb-3">
                    For: High-risk breakables like glass, ceramics, or
                    electronics
                  </h6>
                  <p>
                     We use internal cushioning (bubble wrap, foam chips,
                    thermocol, packing paper) and layer it with wooden or
                    reinforced exteriors—ensuring even delicate items survive
                    international travel.
                  </p>
                  <ul>
                    <li>
                      <p>Multi-layer cushioning</p>
                    </li>
                    <li>
                      <p>Shock-resistant materials</p>
                    </li>
                    <li>
                      <p>Built to absorb transit stress</p>
                    </li>
                  </ul>
                  <button
                    className="btn getquoteBtn mt-2 mb-0 m-0"
                    onClick={handleOpen}
                  >
                    Request a Quote
                  </button>
                </div>
              </div>
              <div className="col-md-6">
                <div className="transit-insurance-service-img">
                  <img
                    src="/assets/images/customised-packing-items.png"
                    alt="Not found"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      <CommonModal open={open} onClose={handleClose} fullWidth={true}>
        <CommonModalTitle>Packaging Enquiry Form</CommonModalTitle>
        <PackagingEnquiryForm handleClose={handleClose} />
      </CommonModal>
    </div>
  );
}
